import type { ComponentType } from "react";
import { m } from "@/paraglide/messages";
import { BmrCalc } from "./components/BmrCalc";
import { HealthyWeightCalc } from "./components/HealthyWeightCalc";

export interface FaqItem {
  q: () => string;
  a: () => string;
}

export interface HealthCalcDef {
  slug: string;
  path: string;
  icon: string;
  navName: () => string;
  metaTitle: () => string;
  metaDescription: () => string;
  h1: () => string;
  intro: () => string;
  howTo: () => string;
  faqs: FaqItem[];
  Component: ComponentType;
}

const BASE = "/bmi-calculator";

export const CALCULATORS: Record<string, HealthCalcDef> = {
  "bmr-calculator": {
    slug: "bmr-calculator",
    path: `${BASE}/bmr-calculator`,
    icon: "🔥",
    navName: () => m.bmr_nav(),
    metaTitle: () => m.bmr_meta_title(),
    metaDescription: () => m.bmr_meta_description(),
    h1: () => m.bmr_h1(),
    intro: () => m.bmr_intro(),
    howTo: () => m.bmr_howto(),
    faqs: [
      { q: () => m.bmr_faq1_q(), a: () => m.bmr_faq1_a() },
      { q: () => m.bmr_faq2_q(), a: () => m.bmr_faq2_a() },
      { q: () => m.bmr_faq3_q(), a: () => m.bmr_faq3_a() },
      { q: () => m.bmr_faq4_q(), a: () => m.bmr_faq4_a() },
    ],
    Component: BmrCalc,
  },
  "ideal-weight": {
    slug: "ideal-weight",
    path: `${BASE}/ideal-weight`,
    icon: "⚖️",
    navName: () => m.hw_nav(),
    metaTitle: () => m.hw_meta_title(),
    metaDescription: () => m.hw_meta_description(),
    h1: () => m.hw_h1(),
    intro: () => m.hw_intro(),
    howTo: () => m.hw_howto(),
    faqs: [
      { q: () => m.hw_faq1_q(), a: () => m.hw_faq1_a() },
      { q: () => m.hw_faq2_q(), a: () => m.hw_faq2_a() },
      { q: () => m.hw_faq3_q(), a: () => m.hw_faq3_a() },
      { q: () => m.hw_faq4_q(), a: () => m.hw_faq4_a() },
    ],
    Component: HealthyWeightCalc,
  },
};

export const CALCULATOR_LIST: HealthCalcDef[] = Object.values(CALCULATORS);

/** Safe lookup (`Object.hasOwn` so inherited keys don't resolve and 500). */
export function getCalculator(slug: string): HealthCalcDef | undefined {
  return Object.hasOwn(CALCULATORS, slug) ? CALCULATORS[slug] : undefined;
}
